/**
 * Lecturas al backend para la ventana «Reemplazar fuente»: pestañas de un archivo y columnas de
 * una pestaña, sin tocar el estado del reporte.
 */
import { engineFetch, engineErrorMessage, parseSpreadsheetInput } from './engineConfig';

/**
 * Pestañas de un spreadsheet a partir de su enlace o ID.
 * @returns {Promise<{ spreadsheet_id: string, sheets: Array<{title, gid}> }>}
 */
export async function fetchWorksheets(input) {
    const parsed = parseSpreadsheetInput(input);
    if (!parsed.spreadsheet_id) throw new Error('Pega el enlace de Google Sheets o el ID del archivo.');
    const response = await engineFetch('/api/engine/worksheets', {
        method: 'POST',
        body: JSON.stringify({ url: input, spreadsheet_id: parsed.spreadsheet_id, refresh: true }),
    });
    if (!response.ok) throw new Error(await engineErrorMessage(response, 'No se pudieron listar las pestañas del archivo.'));
    const res = await response.json();
    const sheets = res.sheets || [];
    if (!sheets.length) throw new Error('El archivo no tiene pestañas visibles.');
    return { spreadsheet_id: res.spreadsheet_id || parsed.spreadsheet_id, sheets };
}

/**
 * Columnas (con tipo) de una pestaña.
 * @returns {Promise<Array<{name, inferred_type}>>}
 */
export async function fetchSheetColumns({ spreadsheet_id, sheet_name }) {
    const response = await engineFetch('/api/engine/schema', {
        method: 'POST',
        body: JSON.stringify({ spreadsheet_id, sheet_name, refresh: true }),
    });
    if (!response.ok) throw new Error(await engineErrorMessage(response, 'No se pudieron leer las columnas de la pestaña.'));
    const res = await response.json();
    if (!res.success || !res.columns?.length) throw new Error('La pestaña no tiene columnas legibles.');
    return res.columns.map(col => ({ name: col.name, inferred_type: col.inferred_type }));
}
